// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__UiIRZ","footerText":"Footer_footerText__kPfhu","footerLinksContainer":"Footer_footerLinksContainer__3ne_L"};